import { render, staticRenderFns } from "./addorg.vue?vue&type=template&id=2ca3715e&"
import script from "./addorg.vue?vue&type=script&lang=js&"
export * from "./addorg.vue?vue&type=script&lang=js&"
import style0 from "./addorg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports